import type { ServiceClient } from '@/api/http/client';

/**
 * 결과가 불명확한 슬롯 요청을 메모리에만 보존한다. 서버의 미해결 상태는 슬롯마다 따로이므로
 * 보존도 client 안에서 슬롯 단위다 — 한 슬롯의 불명 요청이 다른 슬롯을 막지 않는다.
 */
export interface HeldUnitRequest {
  namespace: string;
  generation: number;
  unitId: string;
  unitName: string;
  roomName: string;
}
export function createHeldStore<T extends HeldUnitRequest>() {
  const byClient = new WeakMap<ServiceClient, Map<string, T>>();
  return {
    get: (client: ServiceClient, unitId: string) => byClient.get(client)?.get(unitId),
    set: (client: ServiceClient, intent: T) => {
      let held = byClient.get(client);
      if (!held) {
        held = new Map();
        byClient.set(client, held);
      }
      held.set(intent.unitId, intent);
    },
    delete: (client: ServiceClient, unitId: string) => byClient.get(client)?.delete(unitId),
    /**
     * 같은 세션(namespace·generation)이고 `visible`일 때만 대상 이름을 알려 주고,
     * 그 밖에는 이름 없이 개수만 알려 업무 정보를 노출하지 않는다.
     */
    pending: (client: ServiceClient, namespace: string, generation: number, visible: boolean) => {
      const held = [...(byClient.get(client)?.values() ?? [])].filter(
        (i) => i.namespace === namespace,
      );
      return {
        count: held.length,
        items: visible
          ? held
              .filter((i) => i.generation === generation)
              .map((i) => ({ unitId: i.unitId, unitName: i.unitName, roomName: i.roomName }))
          : [],
      };
    },
  };
}
